var _excluded = ["children", "animation", "withOutsideClose", "withFrame", "onClose", "showCloseIcon", "maxWidth"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* globals document */

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Content from './Content/Content';
import { ModalWrapper, Overlay, ContentWrapper } from './style';
var ModalLegacy = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalLegacy, _React$Component);
  var _super = _createSuper(ModalLegacy);
  function ModalLegacy(props) {
    var _this;
    _classCallCheck(this, ModalLegacy);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.modalRoot.appendChild(_this.el);
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      document.body.removeChild(_this.modalRoot);
    });
    _this.el = document.createElement('div');
    _this.modalRoot = document.createElement('div');
    _this.modalRoot.setAttribute('id', "".concat(props.id, "-modal-root"));
    document.body.appendChild(_this.modalRoot);
    return _this;
  }
  _createClass(ModalLegacy, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        animation = _this$props.animation,
        withOutsideClose = _this$props.withOutsideClose,
        withFrame = _this$props.withFrame,
        onClose = _this$props.onClose,
        showCloseIcon = _this$props.showCloseIcon,
        maxWidth = _this$props.maxWidth,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(ModalWrapper, rest, /*#__PURE__*/React.createElement(Overlay, null), /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(Content, {
        animation: animation,
        withOutsideClose: withOutsideClose,
        withFrame: withFrame,
        onClose: onClose,
        showCloseIcon: showCloseIcon,
        maxWidth: maxWidth
      }, children))), this.el);
    }
  }]);
  return ModalLegacy;
}(React.Component);
_defineProperty(ModalLegacy, "ContentWrapper", ContentWrapper);
ModalLegacy.defaultProps = {
  children: null,
  id: 'unset',
  animation: 'fadeIn',
  withOutsideClose: false,
  withFrame: true,
  onClose: null,
  showCloseIcon: true,
  maxWidth: null
};
ModalLegacy.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  animation: PropTypes.oneOf(['fadeIn', 'slideFromRight']),
  /**
   * decides if close the modal on click on the overlay
   */
  withOutsideClose: PropTypes.bool,
  /**
   * adds padding to all sided arround the content of the modal
   */
  withFrame: PropTypes.bool,
  onClose: PropTypes.func,
  showCloseIcon: PropTypes.bool,
  maxWidth: PropTypes.number
};
ModalLegacy.displayName = 'ModalLegacy';
export default ModalLegacy;